import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _CancelLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("circle", { cx: 12, cy: 12, r: 9, stroke: "currentColor" }),
            React.createElement("path", { stroke: "currentColor", d: "M18 18 6 6" })));
}
const CancelLight = forwardRef(_CancelLight);
export { CancelLight };
